/**
 * Represents the page selection dropdown
 * @constructor
 * @param {Number} iTotalPages   the total number of pages
 * @param {Number} iCurrentPage  the current page
 */
define(['jquery', 'c21/results', 'c21/maps/PaginatorButtons'], function ($, results, PaginatorButtons) {
   "use strict";

   return function (iTotalPages, iCurrentPage) {
      var jPageSelector = $("#pageSelector"),
         m_paginatorButtons = new PaginatorButtons(),

         /**
          * Add Paginator Option
          * @param {Number} totalpages
          * @param {Number} currentpage
          */
         addPaginatorOptions = function (totalpages, currentpage) {
            var elSel = jPageSelector.get(0),
               i;

            // Clear all the options
            jPageSelector.empty();

            if (elSel) {
               // Add new options
               for (i = 1; i <= totalpages; i++) {
                  var elOptNew = document.createElement('option');
                  elOptNew.text = i;
                  elOptNew.value = i;

                  if (currentpage === i) {
                     elOptNew.selected = true;
                  }

                  try {
                     elSel.add(elOptNew, null); // standards compliant; doesn't work in IE
                  } catch (ex) {
                     elSel.add(elOptNew); // IE only
                  }
               }
            }
         },

         initialize = function () {
            addPaginatorOptions(iTotalPages, iCurrentPage);
            m_paginatorButtons.updatePaginatorButtons(iCurrentPage, iTotalPages);
         };

      initialize();
   };
});
